import React from 'react';
import { Button } from '../../../../../components/MuiGenerals';
import { useTranslation } from '../../../../../hooks';
import ShowMoreButton from './ShowMoreButton';

interface ExpandableTextProps {
  text?: string;
  maxChars?: number;
}

const ExpandableText = ({ text = '', maxChars = 32 }: ExpandableTextProps) => {
  const [expanded, setExpanded] = React.useState(false);

  const { tc } = useTranslation();

  if (!text) return null;

  const shouldTruncate = text.length > maxChars;
  const displayText = shouldTruncate && !expanded ? `${text.slice(0, maxChars)}...` : text;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <div
        style={{
          fontFamily: 'monospace',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
        }}
      >
        {displayText}
      </div>
      {shouldTruncate && (
        <ShowMoreButton onClick={() => setExpanded((prev) => !prev)} isExpanded={expanded} />
      )}
    </div>
  );
};

export default ExpandableText;
